import { useCallback, useEffect, useState } from "react";
import {
  loadSavedFilterSelection,
  persistFilterSelection,
  sanitizeFilterSelection,
} from "../utils/filterStorage";

export const useDashboardFilters = () => {
  const [selectedTypes, setSelectedTypes] = useState(() =>
    loadSavedFilterSelection()
  );

  // Accepts either an array or a React-style updater. Without the updater
  // branch a function reaches sanitizeFilterSelection, fails its Array.isArray
  // check and comes back as "everything selected" — so callers like
  // toggleAllFilters silently did the opposite of what they asked for.
  const handleSelectedTypesChange = useCallback((values) => {
    setSelectedTypes((prev) =>
      sanitizeFilterSelection(
        typeof values === "function" ? values(prev) : values
      )
    );
  }, []);

  useEffect(() => {
    persistFilterSelection(selectedTypes);
  }, [selectedTypes]);

  return {
    selectedTypes,
    setSelectedTypes: handleSelectedTypesChange,
  };
};
